import { apiRequest } from './apiRequest';
import type { FeatureFlagsMap } from '../../types/api/featureFlags';

export const featureFlagsAPI = {
  getFlags: async (): Promise<FeatureFlagsMap> => {
    const data = await apiRequest<FeatureFlagsMap | { flags?: FeatureFlagsMap }>(
      '/api/feature-flags',
      { method: 'GET' },
    );
    if (data && typeof data === 'object' && 'flags' in data && data.flags) {
      return data.flags as FeatureFlagsMap;
    }
    return (data ?? {}) as FeatureFlagsMap;
  },
  patchFlags: async (flags: FeatureFlagsMap) => {
    return apiRequest<any>('/api/feature-flags', {
      method: 'PATCH',
      body: JSON.stringify({ flags }),
    });
  },
};
